import React, { Fragment } from 'react';
import FixedBottomNavBar from '../../../../components/FixedBottomNavBar';
import {
  BALANCE_STATUS,
  UPDATE_BALANCE_CONFIRM_MESSAGE_TYPE,
} from '../../../../constants/service/app/balanceConstants';
import Button from '../../../../components/Button';
import './BalanceDetailNavbar.scss';

const BalanceDetailNavbar = (props) => {
  const { status, editBalance } = props;

  return (
    <FixedBottomNavBar className="balance-detail-navbar">
      {status !== BALANCE_STATUS.DONE && (
        <Fragment>
          {/*정산처리*/}
          <Button
            color="primary"
            text="정산처리"
            onClick={() =>
              editBalance({
                msgType: UPDATE_BALANCE_CONFIRM_MESSAGE_TYPE.EXECUTION,
                targetStatus: BALANCE_STATUS.DONE,
              })
            }
          />

          {/*일부완료*/}
          <Button
            color="light"
            text="일부완료"
            onClick={() =>
              editBalance({
                msgType: UPDATE_BALANCE_CONFIRM_MESSAGE_TYPE.PART_EXECUTION,
                targetStatus: BALANCE_STATUS.PART_DONE,
              })
            }
          />

          {/*강제처리*/}
          <Button
            color="gray"
            text="강제처리"
            onClick={() =>
              editBalance({
                msgType: UPDATE_BALANCE_CONFIRM_MESSAGE_TYPE.FORCE_EXECUTION,
                targetStatus: BALANCE_STATUS.DONE,
              })
            }
          />
        </Fragment>
      )}

      {/*수정하기*/}
      <Button
        color="light"
        text="수정하기"
        onClick={() =>
          editBalance({
            msgType: UPDATE_BALANCE_CONFIRM_MESSAGE_TYPE.EDIT_BALANCE,
          })
        }
      />
    </FixedBottomNavBar>
  );
};

export default BalanceDetailNavbar;
